import { render, staticRenderFns } from "./new.venue-events.page.vue?vue&type=template&id=2136d306&"
import script from "./new.venue-events.page.vue?vue&type=script&lang=js&"
export * from "./new.venue-events.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports